<template>
    <div class="userParent">
        <div class="tableBox">
            <p class="p16">第三方登录</p>
            <p class="p14">完善以下信息，即可使用手机号登录版权家了</p>
            <Form 
                ref="mobileLoginForm"
                :model="form"
                :rules="rules"
                class="form"
            >
                <FormItem  class="loginInput" prop="mobilePhone">
                    <div class="logincom">
                        <div class="loginlabel">手机号：</div>
                         <!-- @on-blur="checkRegister()" -->
                          <!-- @on-change="ver_disabled = 'none' " -->
                        <Input
                            type="text"
                            maxlength="11"
                            v-model="form.mobilePhone"
                            placeholder="请输入手机号"
                            autocomplete="off"                          
                           
                        />
                    </div>
                </FormItem>
                <FormItem  class="loginInput" prop="verifyCode">
                    <div class="logincom">
                        <div class="loginlabel">验证码：</div>
                        <Input
                            type="text"
                            v-model="form.verifyCode"
                            placeholder="请输入验证码"
                            autocomplete="off"
                        />
                        <!-- :style="{pointerEvents:ver_disabled}" -->
                        <div @click="_postLoginSendSmsCode('3')" class="loginVertial">{{verifyCode_time}}</div>
                    </div>
                </FormItem>
                <FormItem  class="loginInput" prop="nikeName">
                    <div class="logincom">
                        <div class="loginlabel">昵称：</div>
                        <Input
                            type="text"
                            maxlength="20"
                            v-model="form.nikeName"
                            placeholder="请输入昵称"
                            autocomplete="off"
                        />
                    </div>
                </FormItem>
                <FormItem  class="loginInput" prop="password" :style="{ marginBottom: marginBottom + 'px' }">
                    <div class="logincom">
                        <div class="loginlabel">密码：</div>
                        <Input
                            type="password"
                            v-model="form.password"
                            placeholder="请输入密码"
                            autocomplete="off"
                        />
                    </div>
                </FormItem>
                <FormItem  class="loginInput" prop="nextPassword" :style="{ marginBottom: marginBottom + 'px' }">
                    <div class="logincom">
                        <div class="loginlabel" style="width:70px;margin-right:0px">确认密码：</div>
                        <Input
                            type="password"
                            v-model="form.nextPassword"
                            placeholder="请确认密码"
                            autocomplete="off"
                        />
                    </div>
                </FormItem>
                <!-- <FormItem  class="loginInput" prop="inviteCode">
                    <div class="logincom">
                        <div class="loginlabel">邀请码：</div>
                        <Input
                            type="text"
                            v-model="form.inviteCode"
                            placeholder="好友邀请码(非必填)"
                            autocomplete="off"
                        />
                    </div>
                </FormItem> -->
                <FormItem>
                    <div style="display:flex;justify-content:space-between">
                        <div class="fuxy">
                            <img @click="checkchdata" :src="checkboxmn=='Y'?ye:noye" alt='版权登记'/>
                            <p>阅读并同意</p>
                            <a @click="lawLink">《注册协议及隐私协议》</a>
                        </div>
                        
                    </div>
                </FormItem>
            </Form>
            <div style="text-align:center;">
                <Button class="login-btn" type="primary" size="large" @click="submitLogin" >
                    <span>绑定并登录</span>
                </Button>
            </div>
            
        </div>
    </div>
</template>
<script>
import { login, userInfo,bindUser } from "@/api/index";
import { postLoginSendSmsCode} from "@/api/staticPage";
import { validateMobile,validatePassword } from "@/libs/validate";
import Cookies from "js-cookie";
import  util from  '@/libs/util';

    export default {
        name: 'thirdLogin',
        data() {
            const validatePass = (rule, value, callback) => {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value) && value!='')) {
                    this.marginBottom=36;
                    callback(new Error('请输入正确的密码，必须包含英文字母和数字，8到20位，不允许包含符号'));
                } else {
                    if (this.form.nextPassword !== '') {
                        // 对第二个密码框单独验证
                         this.$refs.mobileLoginForm.validateField('nextPassword');

                    }
                    callback();
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value) && value!='')) {
                    this.marginBottom=36;
                    callback(new Error('请输入正确的密码，必须包含英文字母和数字，8到20位，不允许包含符号'));
                } else if (value !== this.form.password) {
                    this.marginBottom=26;
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    this.marginBottom=26;
                    callback();
                }
            }
            return {
                marginBottom:26,
                ver_disabled:'auto',
                verifyCode_time:'获取',
                ye:require('../assets/images/new_lo_ye.png'),
                noye:require('../assets/images/new_lo_hu.png'),
                form: {
                    password: "",
                    verifyCode:'',
                    inviteCode:"",
                    code: "",
                    nextPassword: "",
                    mobilePhone: "",
                    nikeName:""
                }, 
                checkboxmn:'N',
                rules: {
                    nikeName: [
                    {
                        required: false,
                        message: "",
                        trigger: "blur"
                    }
                    ],
                    verifyCode:[
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur"
                    }
                    ],
                    password: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: validatePass,
                        trigger: "blur"
                    }
                    ],
                    nextPassword:[
                    {
                        required: true,
                        message: "确认密码不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: validatePassCheck,
                        trigger: "blur"
                    }
                    ],
                    mobilePhone:[
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: validateMobile,
                        trigger: "blur"
                    }
                    ]
                },
                 
            }
            
        },
        methods: {
            //服务协议
            lawLink(){
                window.open('/instrument/2','_blank')
            },
            checkchdata(){
                this.checkboxmn = this.checkboxmn == 'Y'?'N':'Y'
            },
            //手机号
            checkRegister(){
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;               
                if (!myreg.test(this.form.mobilePhone)) {
                    toast('手机号格式不正确')
                    return false;
                } else {
                    console.log('手机号格式正确')
                }               
            },
            //验证码
            _postLoginSendSmsCode(type){
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let params;
                let _this = this
                if(type==3){
                    if(this.form.mobilePhone == ''){
                        return false;
                    }else if (!myreg.test(this.form.mobilePhone)) {
                        // toast('手机号格式不正确')
                        return false;
                    } else {
                        console.log('手机号格式正确')
                        params = {
                            mobile:this.form.mobilePhone,
                            type:type
                        }
                        //发送验证码
                        postLoginSendSmsCode(params).then(res=>{
                            if(res.code == 200){
                                this.verifyCode_time = 60
                                this.ver_disabled = 'none'
                                const timer = setInterval(() => {
                                    if(this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                        this.verifyCode_time = this.verifyCode_time-1
                                    }else{
                                        clearInterval(timer);
                                        this.verifyCode_time = '获取'
                                        this.ver_disabled = 'auto'
                                    }
                                }, 1000)
                            }else{
                                toast(res.message)
                            }                   
                        })
                    }
                }
                
            },
            //绑定
            submitLogin() {       
                this.$refs.mobileLoginForm.validate(valid => {
                    if (valid) {                   
                        if(this.checkboxmn=='N'){
                            toast('请勾选并同意注册协议及隐私协议')
                            return false;
                        }                       
                        const data ={
                            token:this.$route.params.id,
                            mobilePhone	:this.form.mobilePhone,
                            verifyCode:this.form.verifyCode,
                            password:this.form.password,
                            nextPassword:this.form.nextPassword,
                            nickName:this.form.nikeName
                        }
                        console.log(data)
                        bindUser(data).then(res => {
                            if(res.code==200){
                                console.log(res.result)
                                // this.$router.push({name:'home_index',query: {data:res.result}})
                                // let accessToken = res.result;
                                this.setStore("accessToken", res.result);
                                userInfo().then(res => {
                                    if (res.code == 200) {
                                        // 避免超过大小限制
                                        if (this.saveLogin) {
                                            // 保存7天
                                            Cookies.set("userInfo", JSON.stringify(res.result), {
                                                expires: 7
                                            });
                                        } else {
                                            Cookies.set("userInfo", JSON.stringify(res.result));
                                        }
                                        this.setStore("userInfo", res.result);
                                        let photo = res.result.photo ? res.result.photo : ''
                                        this.$emit('childFn', photo);
                                        this.$store.commit("setAvatarPath", photo);
                                        // 加载菜单
                                        util.initRouter(this);
                                        this.$router.push({
                                            name: "home_index"
                                        });
                                    }
                                });
                            }else{
                                toast(res.message)
                            }
                        })
                    }
                });
                 
            },



        },
      
    }
</script>

<style scoped lang="less">
.userParent {
    width: 100%;
    background: rgba(255,255,255,1);
    padding: 44px 0px 89px;
    .tableBox{
        width:432px;
        height:564px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        margin:0 auto;
        overflow: hidden;
        .p16{
            font-size:16px;
            font-weight:600;
            color:rgba(51,51,51,1);
            line-height:22px;
            margin:30px 0 10px 30px;
        }
        .p14{
            font-size:14px;
            font-weight:400;
            color:rgba(78,78,78,1);
            line-height:20px;
            margin-left: 30px;
            margin-bottom: 30px;
        }
    }
    .loginInput{
        width:372px;
        height:40px;
        line-height:40px;
        margin: 0 auto 26px;
        .logincom{
            position:relative;
            .loginVertial{
                position: absolute;
                width:48px;
                height:24px;
                line-height: 24px;
                background:rgba(255,216,0,1);
                border-radius:4px;
                right:10px;
                top:8px;
                text-align:center;
                font-size:12px;
                font-weight:400;
                color:rgba(50,50,50,1);
                cursor:pointer;
            }
            .loginlabel{
                position: absolute;
                left: 10px;
                width: 56px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                z-index: 5;
                height: 40px;
                line-height: 40px;
                
            }
            /deep/ .ivu-input{
                // position:absolute;
                // left:0;
                // z-index:3;
                text-indent:76px;
                height: 40px;
                border-radius:4px;
                border:1px solid rgba(222,226,230,1);
                outline: none;
                box-shadow: none;
            }
        }   
    }
    .fuxy{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 30px;
        img{
            margin-right:10px;
            cursor: pointer;
        }
        p{
            height:20px;
            font-size:14px;
            font-weight:400;
            color:#333333;
            line-height:20px;
        }
        a{
            height:20px;
            font-size:14px;
            font-weight:400;
            color:#4C94FF;
            line-height:20px;
        }
    }
    .login-btn{
        width:372px;
        height:42px;
        line-height: 42px;
        border:0;
        background:rgba(255,216,0,1);
        border-radius:4px;
        font-size:14px;
        font-weight:600;
        color:rgba(78,78,78,1);
        outline: none;
        cursor: pointer;
        box-shadow: none;
    }
    /deep/ .ivu-form-item-validating .ivu-input-icon-validate{
        display: none;
    }
}


</style>